import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

import { API_PATH } from "@/constants/config";
import { request } from "@/helper/http";
import { type RetentionPolicyResponse, type RetentionPolicy } from "@/types/retentionPolicy";

export const getRetentionPolicy = (): Promise<RetentionPolicyResponse> => {
  return request({
    method: "GET",
    url: API_PATH.SYSTEM_SETTINGS_RETENTION_POLICIES,
  });
};
export const updateRetentionPolicy = (data: RetentionPolicy): Promise<void> => {
  return request({
    method: "PUT",
    url: API_PATH.SYSTEM_SETTINGS_RETENTION_POLICIES,
    data: {
      enabled: data.enabled,
      retention_days: data.retentionDays,
    },
  });
};

export const retentionPoliciesApi = createApi({
  reducerPath: "retentionPoliciesApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["RetentionPolicy"],
  endpoints: (build) => ({
    getRetentionPolicies: build.query({
      queryFn: async () => {
        try {
          const data = await getRetentionPolicy();
          return {
            data: {
              enabled: data.enabled,
              retentionDays: data.retention_days,
            },
          };
        } catch (error) {
          return {
            error,
          };
        }
      },
      providesTags: ["RetentionPolicy"],
    }),
    updateRetentionPolicy: build.mutation({
      queryFn: async (data) => {
        await updateRetentionPolicy(data);
        return { data: undefined };
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        dispatch(
          retentionPoliciesApi.util.updateQueryData("getRetentionPolicies", {}, (draft) => {
            if (draft) {
              Object.assign(draft, arg);
            }
          })
        );
        await queryFulfilled;
      },
    }),
  }),
});

export const { useGetRetentionPoliciesQuery, useUpdateRetentionPolicyMutation } = retentionPoliciesApi;
